import { logger } from '@/common/api/logger';

/**
 * Mirrors vendor pleased-sdk Tags.clean / system tag rules for live chat requests.
 */
const REMOVE_UNSUPPORTED_SYSTEM_TAGS = false;
const REMOVE_RAW_TAGS = false;

const SUPPORTED_SYSTEM_TAGS = ['language', 'country'];
const SYSTEM_TAG_REGEX = /(^[ A-Za-z0-9_@#&+-]+)=([ A-Za-z0-9_@./#&+-]*$)/i;

const isSystemTag = (tag: string) => SYSTEM_TAG_REGEX.test(tag);

const isSupported = (key: string) => SUPPORTED_SYSTEM_TAGS.includes(key);

const parse = (tag: string): [string, string] => {
  const [, key = '', value = ''] = tag.match(SYSTEM_TAG_REGEX) || [];
  if (!key) {
    logger.error('[CHAT_SYSTEM_TAGS] Invalid system tag', { tag });
  }
  return [key, value];
};

/**
 * Trims, filters, and lowercases tags like the legacy SDK `Tags.clean`.
 */
export const cleanChatSystemTags = (tags: string[]): string[] => {
  if (!tags?.length) return [];
  return tags
    .map((s) => (s || '')?.trim())
    .filter(Boolean)
    .filter((tag) => {
      if (!isSystemTag(tag)) return REMOVE_RAW_TAGS;
      if (!REMOVE_UNSUPPORTED_SYSTEM_TAGS) return true;
      const [key] = parse(tag);
      return isSupported(key);
    })
    .map((s) => s.toLowerCase());
};
